import React, { createContext, ReactNode, useContext, useState } from 'react';
import { noop } from 'lodash';
import useNewPatientStep from './Steps/steps';
import { IOnBoardingDrawerContextData, IWizardProviderProps } from './hooks/types';
import useQueryParam from '../../../../hooks/useCustomQueryParam';

export const onBoardingDrawerContext = createContext<IWizardProviderProps>({
  moveToStep: noop,
  goToLastStep: noop,
  goBack: noop,
  activeStep: 0,
  setContextData: noop,
  contextData: {} as IOnBoardingDrawerContextData,
});

export default function OnBoardingDrawerProvider({
  children,
}: {
  children: ReactNode;
}) {
  const [, setNewPatient] = useQueryParam<string | undefined>('newPatientUuid');
  const [data, setData] = useState<IOnBoardingDrawerContextData>({});
  const [activeStep, setActiveStep] = useState<number>(0);
  const steps = useNewPatientStep();

  const moveToStep = (step: number) => {
    if (step < steps.length - 1) setActiveStep(step + 1);
    else setNewPatient(undefined);
  };
  const goBack = (step: number) => {
    setActiveStep(step - 1);
  };

  const goToLastStep = () => {
    if (activeStep < steps.length - 1) {
      setActiveStep(steps?.length - 1);
    } else setNewPatient(undefined);
  };

  return (
    <onBoardingDrawerContext.Provider
      value={{
        goBack,
        moveToStep,
        activeStep,
        goToLastStep,
        contextData: data ?? {},
        setContextData: (contextData: IOnBoardingDrawerContextData) => {
          setData({ ...data, ...contextData });
        },
      }}>
      {children}
    </onBoardingDrawerContext.Provider>
  );
}

export const useOnBoardingDrawer = () => useContext(onBoardingDrawerContext);
